import React, { Component } from 'react';
import styles from './index.module.less';

export default class Footer extends Component {

  render() {
    return (
      <div className={styles.copyrightWrapper}>
        {/*<p className={styles.copyHeader}>*/}
          {/*<a>关于我们</a>*/}
          {/*<a>法律声明及隐私权政策</a>*/}
          {/*<a>廉政举报</a>*/}
          {/*<a>联系我们</a>*/}
          {/*<a>加入大搜车</a>*/}
        {/*</p>*/}
        <p className={styles.copyright}>
          ©2009-2019 open.souche.com 版权所有 ICP证： 京ICP备13012136号-2
        </p>
        {/*<p className={styles.police}>*/}
          {/*<a  target="_blank" href="http://idinfo.zjaic.gov.cn/bscx.do?method=lzxx&id=3301963301080000025024">*/}
            {/*<img src="//gw.alicdn.com/tfs/TB1GxwdSXXXXXa.aXXXXXXXXXXX-65-70.gif"/>*/}
          {/*</a>*/}
          {/*<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?COLLCC=2716891795&recordcode=33010602009975">*/}
            {/*<img src="//img.alicdn.com/tfs/TB1..50QpXXXXX7XpXXXXXXXXXX-40-40.png"/>*/}
            {/*<span>浙公网安备3301060209975号</span>*/}
          {/*</a>*/}
        {/*</p>*/}
      </div>
    )
  }
}
